module.exports = __webpack_public_path__ + "img/item_1.a515daa8.png";